import React from 'react';
import Scrollbar from 'react-scrollbars-custom';

import { Layout } from 'antd';
import PropTypes from 'prop-types';

import Footer from './Footer';
import Header from './Header';

const { Content } = Layout;

function Main({ children }) {
  return (
    <Layout>
      <Header />
      <Content>
        <Scrollbar>{children}</Scrollbar>
      </Content>
      <Footer />
    </Layout>
  );
}

Main.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Main;
